import UpcomingWebinarItem from "./UpcomingWebinarItem";
import React, { PropTypes } from "react";

const UpcomingWebinars = ({
  webinars,
  nextPage,
  pagination,
  count,
  noTitle,
}) => (
  <div>
    <div className={`container_upcoming row ${noTitle ? "noTitle" : ""}`}>
      {/* <h2 id="upcoming" className="section_upcoming_title">UPCOMING WEBINARS {count ? `(${count})` : '(0)'}</h2> */}
      <h2 id="upcoming" className="section_upcoming_title">
        Upcoming Meetings
      </h2>
      <div className={`section_upcoming_block ${noTitle ? "noTitle" : ""}`}>
        {typeof webinars === "function" ? webinars(noTitle) : webinars}
      </div>
    </div>

    {/* {pagination && <a className="more_item" href="javascript:void(0)" onClick={nextPage}>LOAD MORE</a>} */}
    {!webinars.length && (
      <p className="has_no_items">There are no upcoming webinars currently</p>
    )}
  </div>
);

UpcomingWebinars.propTypes = {
  webinar: PropTypes.obj,
};

export default UpcomingWebinars;



// WEBPACK FOOTER //
// ./src/components/Dashboard/UpcomingWebinars/UpcomingWebinars.js